import { createSlice } from '@reduxjs/toolkit';

// Initial state definition
const initialState = {
    facilityLocationData: {
        facilityName: '',
        streetAddress: '',
        addressComponents: {
            street: '',
            state: '',
            country: '',
            zipcode: '',
            city: '',
        }
    },
    colleagueData: {
        firstName: '',
        lastName: '',
        emailAddress: ''
    }
};

// Creating the Redux slice
const facilityLocationSlice = createSlice({
    name: 'addfacilitylocation',
    initialState,
    reducers: {
        // Update facility location data
        setFacilityLocationData: (state, action) => {
            state.facilityLocationData = action.payload;
        },
        // Update colleague data
        setColleagueData: (state, action) => {
            state.colleagueData = action.payload;
        },
        // Clear both facility location and colleague data
        clearFacilityLocationData: (state) => {
            state.facilityLocationData = initialState.facilityLocationData;
            state.colleagueData = initialState.colleagueData;
        }
    }
});

// Exporting the actions
export const { setFacilityLocationData, setColleagueData, clearFacilityLocationData } = facilityLocationSlice.actions;

// Exporting the reducer
export default facilityLocationSlice.reducer;
